import { Form } from "antd";
import styled from "styled-components";

export const LoginContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: ${({ theme }) => theme.token.colorBgLayout};
`;

export const LeftPanel = styled.div`
  flex: 1.2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, ${({ theme }) => theme.token.colorPrimary} 0%, ${({ theme }) => theme.token.colorPrimaryActive} 100%);
  color: white;
  position: relative;
  padding: 4rem;
  
  /* Abstract shape decoration */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  }

  @media (max-width: 900px) {
    display: none;
  }
`;

export const RightPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.token.colorBgContainer};
  padding: 2rem;
  overflow-y: auto;
  position: relative;
`;

export const FormWrapper = styled.div`
  width: 100%;
  max-width: 440px;
  padding: 3rem;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 576px) {
    padding: 1.5rem;
  }
`;

export const StyledForm = styled(Form)`
  width: 100%;
  margin-top: 2rem;

  .ant-form-item {
    margin-bottom: 1.5rem;
  }

  .ant-input, .ant-input-password {
    padding: 0.8rem 1rem;
    font-size: 1rem;
  }
  
  .ant-input-affix-wrapper {
    padding: 0.8rem 1rem;
  }
`;

export const WelcomeTitle = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: white;
  text-align: center;
  line-height: 1.2;
  z-index: 1;
`;

export const WelcomeSubText = styled.p`
  font-size: 1.2rem;
  opacity: 0.9;
  text-align: center;
  max-width: 80%;
  color: white;
  line-height: 1.6;
  z-index: 1;
`;

export const BrandLogo = styled.img`
  width: 180px;
  margin-bottom: 3rem;
  z-index: 1;
  border-radius: 10%;
`;

export const MobileLogo = styled.img`
  width: 100px;
  margin-bottom: 2rem;
  display: none;
  border-radius: 10%;
  @media (max-width: 900px) {
    display: block;
  }
`;

export const LoginTitle = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.token.colorText};
  margin-bottom: 0.5rem;
  text-align: left;
`;

export const LoginSubtitle = styled.p`
  color: ${({ theme }) => theme.token.colorTextSecondary};
  margin-bottom: 1rem;
  text-align: left;
  font-size: 1rem;
`;

export const ActionButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
`;

export const DownloadButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px;
  border-radius: ${({ theme }) => theme.token.borderRadiusLG}px;
  border: 1px solid ${({ theme }) => theme.token.colorBorder};
  color: ${({ theme }) => theme.token.colorText};
  background: transparent;
  transition: all 0.3s ease;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    border-color: ${({ theme }) => theme.token.colorPrimary};
    color: ${({ theme }) => theme.token.colorPrimary};
    background-color: ${({ theme }) => theme.token.colorPrimaryBg};
  }

  .icon {
    font-size: 1.5rem;
  }

  .text {
    font-weight: 500;
  }
`;

export const InstallButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px;
  border-radius: ${({ theme }) => theme.token.borderRadiusLG}px;
  border: 1px solid ${({ theme }) => theme.token.colorBorder};
  color: ${({ theme }) => theme.token.colorText};
  background: transparent;
  transition: all 0.3s ease;
  cursor: pointer;
  width: 100%;

  &:hover {
    border-color: ${({ theme }) => theme.token.colorPrimary};
    color: ${({ theme }) => theme.token.colorPrimary};
    background-color: ${({ theme }) => theme.token.colorPrimaryBg};
  }

  .icon {
    font-size: 1.5rem;
  }

  .text {
    font-weight: 500;
  }
`;
